export const ALL_PLATFORMS = 'All platforms';
